import { gql } from '@apollo/client';

import { getClient } from 'lane-shared/apollo';
import {
  ExceptionDetails,
  TaxAmountType,
  MarkupAmountType,
  ExternalPayerType,
  CreateProductExceptionRequest,
} from 'lane-shared/domains/billingPayments/types';
import { GroupType } from 'graphql-query-contracts';
import { convertToUUID } from 'uuid-encoding';
import { Item } from 'components/form/Dropdown/Dropdown';

export async function createProductExceptionMutation(
  exceptionDetails: ExceptionDetails,
  channelId: string
) {
  const createProductExceptionMutation = gql`
    mutation createProductException(
      $createProductExceptionRequest: CreateProductExceptionRequest!
    ) {
      createProductException(
        createProductExceptionRequest: $createProductExceptionRequest
      ) {
        id
      }
    }
  `;

  const productCategoryId = exceptionDetails.applyToAllProducts
    ? exceptionDetails.productCategoryId
    : undefined;
  const productIds = exceptionDetails.applyToAllProducts
    ? undefined
    : exceptionDetails.productIds
        .map((item: Item<string>) => item.value)
        .join(',');

  const requestDetails = {
    group: {
      id: convertToUUID(channelId),
      type: GroupType.GroupTypeActivateChannel,
    },
    payer: {
      id: convertToUUID(exceptionDetails.invoicee?._id),
      type:
        exceptionDetails.invoicee?.type ||
        ExternalPayerType.EXTERNAL_PAYER_TYPE_ACTIVATE_USER,
    },
    productIds,
    productCategoryId,
    amount: Number(exceptionDetails.rate),
  } as CreateProductExceptionRequest;

  if (exceptionDetails.markup) {
    requestDetails.markup = {
      value: Number(exceptionDetails.markup.value),
      markupAmountType:
        exceptionDetails.markup?.type ||
        MarkupAmountType.MarkupAmountTypePercentage,
    };
  }

  if (exceptionDetails.tax) {
    requestDetails.tax = {
      value: Number(exceptionDetails.tax.value),
      taxAmountType:
        exceptionDetails.tax?.type || TaxAmountType.TaxAmountTypePercentage,
    };
  }

  return await getClient().mutate<
    any,
    { createProductExceptionRequest: CreateProductExceptionRequest }
  >({
    mutation: createProductExceptionMutation,
    variables: {
      createProductExceptionRequest: requestDetails,
    },
  });
}
